import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const VariantTable = ({ variants }) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper} className="table-container">
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Id </TableCell>
              <TableCell align="left">Guid</TableCell>
              <TableCell align="left">Expected Amount</TableCell>
              <TableCell align="left">Populate Amount</TableCell>
              <TableCell align="left">Product Type</TableCell>
              <TableCell align="left">Design Identifier</TableCell>
              <TableCell align="left">Product Id</TableCell>
              <TableCell align="left">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {variants.length > 0 ? (
              variants.map((variant, i) => (
                <TableRow key={i}>
                  <TableCell align="left">{variant.variant_id}</TableCell>
                  <TableCell align="left">{variant.variant_guid}</TableCell>
                  <TableCell align="left">{variant.variant_expectedamount}</TableCell>
                  <TableCell align="left">{variant.variant_product_populateamount}</TableCell>
                  <TableCell align="left">{variant.variant_product_type}</TableCell>
                  <TableCell align="left">{variant.variant_design_identifier}</TableCell>
                  <TableCell align="left">{variant.variant_product_id}</TableCell>
                  <TableCell align="left">{variant.variant_status}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow style={{ height: 53 * 1 }}>
                <TableCell colSpan={6}> No data available in table </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

VariantTable.propTypes = {
  variants: PropTypes.array
};

export default VariantTable;
